import React, { useEffect, useState } from "react";
import { Lesson, LessonState } from "../../types/Lessons";
import Api from "../../network/Api";
import Summary from "./Summary";
import { Alert, Box, Card, Container, FormGroup, Grid, Paper, Skeleton, Stack } from "@mui/material";
import User from "../../types/User";
import Toolbar from "../Solutions/Toolbar";
import CommentBox from "../Comments/CommentBox";
import { MultilineTextField } from "../Shared/FormItems";
import Linkify from "linkify-react";

type LessonParams = {
  mitigation?: string;
  approver?: User | string;
};

const Show = (props: { lessonId: string, user: User }) => {

  const [lesson, setLesson] = useState<Lesson>();

  useEffect(() => {
    Api.get(`/lessons/${props.lessonId}`).then(setLesson);
    Api.get(`/users`).then(setUsers);
  }, []);

  const [users, setUsers] = useState<Array<User>>([]);
  const [params, setParams] = useState<LessonParams>({});
  const [isUpdating, setIsUpdating] = useState<boolean>(false);

  useEffect(() => {
    if (typeof(lesson) === "undefined") { return }
    setParams({...params, ...lesson});
  }, [lesson]);

  const save = (params: LessonParams) => {
    setIsUpdating(true);
    Api.put(`/lessons/${lesson?.id}`, params).then(setSolutionResults);
  }

  const review = () => {
    setIsUpdating(true);
    Api.put(`/lessons/${lesson?.id}`, {state: LessonState[LessonState.review] }).then(setSolutionResults);
  }
  const accept = () => {
    setIsUpdating(true);
    Api.put(`/lessons/${lesson?.id}`, {state: LessonState[LessonState.approved] }).then(setSolutionResults);
  }
  const reject = (comment?: string) => {
    setIsUpdating(true);
    if (comment) {
      Api.post(`/lessons/${lesson?.id}/comments`, { content: comment, color: 'error' });
    }
    Api.put(`/lessons/${lesson?.id}`, {state: LessonState[LessonState.rejected] }).then(result => window.location.reload());
  }
  const reopen = () => {
    setIsUpdating(true);
    Api.put(`/lessons/${lesson?.id}`, {state: LessonState[LessonState.draft] }).then(result => window.location.reload());
  }

  const setSolutionResults = (result) => {
    setLesson(result);
    setIsUpdating(false);
  }

  return <Box sx={{flex: 1, overflowY: 'auto', py: 3, width: "100%"}}>
    <Container maxWidth="xl">
      <Grid container spacing={3}>
        <Grid size={{xs: 12, md: 8}}>
          <Card>
            { lesson && <Summary lesson={lesson} /> }
          </Card>
        </Grid>

        <Grid size={{xs: 12, md: 4}}>
          <Stack spacing={3}>
            <Toolbar lesson={lesson}
                      user={props.user}
                      isUpdating={isUpdating}
                      users={users}
                      onChange={object => setParams({...params, ...object})}
                      onSave={save}
                      onReview={review}
                      onAccept={accept}
                      onReject={reject}
                      onReopen={reopen} />

            <Paper sx={{ p: 3 }}>
              <FormGroup>
                <p><strong>Mitigation { lesson && LessonState[lesson.state] !== LessonState.approved && "proposal" }</strong></p>
              </FormGroup>
              { lesson && params ? <>{ LessonState[lesson.state] !== LessonState.approved ?
                <MultilineTextField
                    name="mitigation"
                    required
                    placeholder="Describe the result e.g. add a mitigation or insert a link to any useful resource that helps resolving the issue."
                    value={params?.mitigation ?? ""}
                    onChange={value => setParams({...params, mitigation: value})}
                    onSave={value => save({mitigation: value})}
                    disabled={LessonState[lesson.state] !== LessonState.draft}
                  /> : <Alert><Linkify options={{target: "_blank"}}>{lesson.mitigation}</Linkify></Alert> } </> : <Skeleton /> }
            </Paper>
            
            { lesson && <CommentBox user={props.user} lesson={lesson} /> }
          </Stack>
        </Grid>
      </Grid>
    </Container>
  </Box>
}

export default Show;